import graphqlClient from "../../../apollo";

class PresupuestoProvider {
  findPresupuesto(id) {
    return graphqlClient.query({
      query: require("./gql/presupuestoFind.graphql"),
      variables: { id },
      fetchPolicy: "network-only",
    });
  }

  paginatePresupuestos(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false, filters = {}) {
    return graphqlClient.query({
      query: require("./gql/presupuestoPaginate.graphql"),
      variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc, filters },
      fetchPolicy: "network-only",
    });
  }

  createPresupuesto(input) {
    return graphqlClient.mutate({
      mutation: require("./gql/presupuestoCreate.graphql"),
      variables: { input },
    });
  }

  updatePresupuesto(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/presupuestoUpdate.graphql"),
      variables: { id, input },
    });
  }

  actualizarPreciosPresupuesto(id) {
    return graphqlClient.mutate({
      mutation: require("./gql/presupuestoActualizarPrecios.graphql"),
      variables: { id },
    });
  }

  modificarPresupuesto(id, input) {
    return graphqlClient.mutate({
      mutation: require("./gql/presupuestoModificar.graphql"),
      variables: { id, input },
    });
  }

  generarPDFBase64(presupuestoId) {
    return graphqlClient.mutate({
      mutation: require("./gql/presupuestoGenerarPDFBase64.graphql"),
      variables: { presupuestoId },
    });
  }

}

export default new PresupuestoProvider();
